import React, { useEffect } from 'react';
import {
  Box,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Text,
} from '@chakra-ui/react';
import { MapContainer, TileLayer, Marker, Polyline, Popup, useMap } from 'react-leaflet';
import L from 'leaflet';

import 'leaflet/dist/leaflet.css';
import './LocationHistoryMapModal.css';

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl:
    'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png',
  iconUrl:
    'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',
  shadowUrl:
    'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',
});

function LocationHistoryMapModal({ isOpen, onClose, locations }) {
  const defaultCenter = [20, 0]; // somewhere around Africa/Europe
  const last = locations && locations.length > 0 ? locations[locations.length - 1] : null;
  const initialCenter = last ? [last.lat, last.lng] : defaultCenter;

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="4xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Product Location History</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Box className="location-history-map-container">
            <MapContainer
              center={initialCenter}
              zoom={3}
              className="location-history-map"
            >
              <TileLayer
                attribution='&copy; OpenStreetMap contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              />
              <LocationHistoryLayer locations={locations} />
            </MapContainer>
          </Box>

          <Text className="location-history-helper-text">
            Showing scan locations in chronological order. The line indicates the travel path of this certificate/product based on recorded scans.
          </Text>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}

function LocationHistoryLayer({ locations }) {
  const map = useMap();

  useEffect(() => {
    if (!locations || locations.length === 0) return;

    const last = locations[locations.length - 1];
    if (last?.lat != null && last?.lng != null) {
      map.flyTo([last.lat, last.lng], 5, {
        duration: 1.5,
      });
    }
  }, [locations, map]);

  const positions = locations.map(loc => [loc.lat, loc.lng]);

  return (
    <>
      {positions.map((pos, idx) => {
        const loc = locations[idx];
        return (
          <Marker key={idx} position={pos}>
            <Popup>
              <div className="location-history-popup">
                <strong>{loc.label || `Scan #${idx + 1}`}</strong>
                {loc.timestamp && (
                  <div className="location-history-popup-line">
                    {new Date(loc.timestamp).toLocaleString()}
                  </div>
                )}
                {loc.accountType && (
                  <div className="location-history-popup-line">
                    Account Type: {loc.accountType}
                  </div>
                )}
                {loc.userName && (
                  <div className="location-history-popup-line">
                    User: {loc.userName}
                  </div>
                )}
              </div>
            </Popup>
          </Marker>
        );
      })}

      {positions.length > 1 && (
        <Polyline positions={positions} />
      )}
    </>
  );
}

export default LocationHistoryMapModal;
